import axios from "axios";
import { API_BASE_URL, getAuthConfig } from "./apiClient";

export const getBrowserTimezone = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Normalize legacy alias used by some browsers
    if (tz === "Asia/Calcutta") {
      return "Asia/Kolkata";
    }

    return tz || "Asia/Kolkata";
  } catch {
    return "Asia/Kolkata";
  }
};

export const fetchMeetingAvailability = async (date, timezone) => {
  const response = await axios.get(`${API_BASE_URL}/meeting-slots/availability`, {
    params: { date, timezone },
  });

  return response.data;
};

export const fetchMeetingBookings = async () => {
  const response = await axios.get(
    `${API_BASE_URL}/meeting-bookings`,
    getAuthConfig(),
  );

  return response.data?.items || [];
};

export const cancelMeetingBooking = async (contactId) => {
  const response = await axios.post(
    `${API_BASE_URL}/meeting-bookings/${encodeURIComponent(contactId)}/cancel`,
    {},
    getAuthConfig(),
  );

  return response.data;
};

export const fetchMeetingInviteEmails = async () => {
  const response = await axios.get(
    `${API_BASE_URL}/settings/meeting-invite-emails`,
    getAuthConfig(),
  );

  return response.data;
};

export const updateMeetingInviteEmails = async (emails) => {
  const response = await axios.put(
    `${API_BASE_URL}/settings/meeting-invite-emails`,
    { emails },
    getAuthConfig(),
  );

  return response.data;
};

export const blockMeetingSlot = async (payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/meeting-slots/blocked`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const unblockMeetingSlot = async (blockedSlotId) => {
  await axios.delete(
    `${API_BASE_URL}/meeting-slots/blocked/${encodeURIComponent(blockedSlotId)}`,
    getAuthConfig(),
  );
};

export const formatSlotTimeLabel = (time24) => {
  if (!time24) {
    return "";
  }

  const [hourPart, minutePart] = time24.split(":");
  let hour = Number(hourPart);
  const suffix = hour >= 12 ? "pm" : "am";

  if (hour === 0) {
    hour = 12;
  } else if (hour > 12) {
    hour -= 12;
  }

  return `${hour}:${minutePart}${suffix}`;
};

export const formatMeetingDateLabel = (dateStr) => {
  if (!dateStr) {
    return "";
  }

  const parsed = new Date(`${dateStr}T12:00:00`);

  return parsed.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};
